import { userGroupsEn } from './en'

export const userGroupsEnCa = userGroupsEn
